export default "__VITE_ASSET__BBGG96_9__"